import { FC } from 'react';
import Image from 'next/image';
import loopyRiverLogo from '@puzzlio/ui/logos/loopy-river.svg';
import { cn } from '@/app/lib/utils';

/*
  The game's logo, from the same file the app draws. The extra classes make the <img> lay out as the
  inline <svg> this used to be: no preflight max-width cap, free to shrink in a flex row, and the
  drawing letterboxed rather than stretched when it does.
*/
export const LoopyRiverLogo: FC<{ className?: string }> = ({ className }) => {
  return (
    <Image src={loopyRiverLogo} alt="" className={cn('size-[120px] max-w-none min-w-0 object-contain', className)} />
  );
};
